import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import CountUp from 'react-countup';
import moment from 'moment';

ChartJS.register(ArcElement, Tooltip, Legend);

const DonutChart = ({ data, title }) => {
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    if (data?.distributions) {
      setSelectedItems(data.distributions);
    }
  }, [data]);

  const toggleLegend = item => {
    setSelectedItems(prev => {
      const isRemoved = prev?.some(d => d?.name === item.name);
      return isRemoved ? prev?.filter(d => d?.name !== item.name) : [...prev, item];
    });
  };

  const pieData = {
    labels: selectedItems.map(item => item.name),
    datasets: [
      {
        data: selectedItems.map(item => item.value),
        backgroundColor: selectedItems.map(item => item.color),
        borderWidth: 1,
        cutout: '65%',
      },
    ],
  };

  const updatedTotalCount = selectedItems.reduce((sum, item) => sum + item.value, 0);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        color: 'white',
        font: {
          weight: 'normal',
        },
      },
    },
  };

  return (
    <Col xl={6} md={12} lg={6} className="mb-2" style={{ borderRadius: '10px' }}>
      <Card>
        <div className="d-flex justify-content-between m-4">
          <h4 className="card-title mb-0 flex-grow-1 fw-semibold">{title}</h4>
        </div>
        <CardBody style={{ maxHeight: '420px', position: 'relative', textAlign: 'center', height: '402px' }}>
          <div style={{ height: '300px', position: 'relative' }}>
            <Doughnut data={pieData} options={options} />

            {/* Total in center */}
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                fontSize: '18px',
                fontWeight: '500',
              }}
            >
              <div style={{ fontSize: '14px', fontWeight: 'normal', color: '#8E8E93' }}>{data?.countsDisplayHeading}</div>
              <CountUp separator="" start={0} end={Number(updatedTotalCount)} duration={2} style={{ fontSize: '25px' }} className="fw-bold" />
            </div>
          </div>

          {/* Custom Legends */}
          <div className="d-flex flex-wrap justify-content-center mt-3">
            {data?.distributions?.map(item => {
              const isSelected = selectedItems.some(d => d.name === item.name);
              return (
                <div
                  key={item.name}
                  onClick={() => toggleLegend(item)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    margin: '3px',
                    padding: '5px 10px',
                    backgroundColor: '#F2F2F7',
                    color: 'black',
                    borderRadius: '10px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500',
                  }}
                >
                  <div
                    style={{
                      width: '13px',
                      height: '13px',
                      backgroundColor: item.color,
                      borderRadius: '3px',
                      marginRight: '8px',
                      border: '1px solid #ccc',
                    }}
                  ></div>
                  <span
                    style={{
                      textDecoration: !isSelected ? 'line-through' : 'none',
                      fontWeight: '400',
                      fontSize: 12,
                    }}
                  >
                    {item.name}
                  </span>
                </div>
              );
            })}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DonutChart;
